module.exports = __webpack_public_path__ + "img/arrow.ba440822.svg";